export const GET_ADMIN_PAGE_SUCCESSFUL = "get_admin_page_successful"
export const GET_ADMIN_PAGE_FAILED = "get_admin_page_failed"